<template>
    <div>
        <debug-stats
                v-show="debugSettings.statsEnabled"
                ref="debugStats"
                :hls="hls"
        ></debug-stats>

        <debug-metrics
                v-show="debugSettings.metricsEnabled"
                ref="debugMetrics"
                :hls="hls"
        ></debug-metrics>
    </div>
</template>
<script>
    import Hls from 'hls.js';
    import DebugStats from './DebugStats.vue';
    import DebugMetrics from './DebugMetrics.vue';

    import {mapState, mapActions} from 'vuex'

    export default {
        components: {DebugStats, DebugMetrics},
        data() {
            return {
                lastDuration: null,
                lastStartPosition: null,
                bufferingIdx: -1,
                events: {url: decodeURIComponent(this.getURLParam('src', this.src)), t0: performance.now(), load: [], buffer: [], video: [], level: [], bitrate: []}
            }
        },
        computed: {
            ...mapState({
                debugSettings: state => state.debug.debugSettings
            })
        },
        props: ['hls'],
        methods: {
            getURLParam(sParam, defaultValue) {
                let sPageURL = window.location.search.substring(1);
                let sURLVariables = sPageURL.split('&');
                for (let i = 0; i < sURLVariables.length; i++) {
                    let sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] == sParam) {
                        return "undefined" == sParameterName[1] ? undefined : "false" == sParameterName[1] ? false : sParameterName[1];
                    }
                }
                return defaultValue;
            },
            addFatalError() {
                let debugComponent = this.$refs.debugStats;
                if (debugComponent.stats.errors.fatalError === undefined) {
                    this.$set(debugComponent.stats.errors, 'fatalError', 1);
                } else {
                    this.$set(debugComponent.stats.errors, 'fatalError', debugComponent.stats.fatalError + 1);
                }
            },
            addError(details) {
                let debugComponent = this.$refs.debugStats;
                if (debugComponent.stats.errors[details] === undefined) {
                    this.$set(debugComponent.stats.errors, details, 1);
                } else {
                    this.$set(debugComponent.stats.errors, details, debugComponent.stats.errors[details] + 1);
                }
            },
            clearEvents() {
                this.events = {url: decodeURIComponent(this.getURLParam('src', this.src)), t0: performance.now(), load: [], buffer: [], video: [], level: [], bitrate: []};
            },
            enableDebug() {
                this.$refs.debugStats && this.$refs.debugStats.enableDebugInfo();
            },
            refreshCanvas() {
                this.$refs.debugMetrics && this.$refs.debugMetrics.refreshCanvas();
            }
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// Debug.vue?2fc82d01